import { defineMessages } from 'react-intl'

export default defineMessages({
  next: {
    id: 'welcomepage.form.next',
    defaultMessage: 'Next',
  },
  createAccount: {
    id: 'welcomepage.form.createAccount',
    defaultMessage: 'Create account',
  },
  login: {
    id: 'welcomepage.form.login',
    defaultMessage: 'Log in',
  },
  loginTitle: {
    id: 'welcomepage.form.logintitle',
    defaultMessage: 'Enter your password',
  },
})
